import { ReactNode } from "react";

/**
 * @deprecated Use tailwind `sr-only` class directly instead.
 */
export default function VisuallyHidden({ children }: { children: ReactNode }) {
  return <span className="sr-only">{children}</span>;
}
